import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const topic = {
  fetchTopic: lazyModuleMethod(() => import('./fetchTopic'), 'default'),
  fetchTopics: lazyModuleMethod(() => import('./fetchTopics'), 'default'),
  createTopic: lazyModuleMethod(() => import('./createTopic'), 'default'),
  updateTopic: lazyModuleMethod(() => import('./updateTopic'), 'default'),
}
